import { render, staticRenderFns } from "./CourseGroupListPage.vue?vue&type=template&id=285962d7&scoped=true"
import script from "./CourseGroupListPage.vue?vue&type=script&lang=js"
export * from "./CourseGroupListPage.vue?vue&type=script&lang=js"
import style0 from "./CourseGroupListPage.vue?vue&type=style&index=0&id=285962d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285962d7",
  null
  
)

export default component.exports